import { useEffect } from 'react';

import { accountApi } from '@api/account/account.api';
import { applicationApi } from '@api/application/application.api';
import { consumerApi } from '@api/consumer/consumer.api';
import { credentialApi } from '@api/credential/credential.api';
import { integrationApi } from '@api/integration/integration.api';
import { userApi } from '@api/user/user.api';
import { accountsActions } from '@store/accounts/accounts.slice';
import { applicationsActions } from '@store/applications/applications.slice';
import { consumersActions } from '@store/consumers/consumers.slice';
import { credentialsActions } from '@store/credentials/credentials.slice';
import { integrationsActions } from '@store/integrations/integrations.slice';
import { logsActions } from '@store/logs/logs.slice';
import { userActions } from '@store/user/user.slice';
import { webhooksActions } from '@store/webhooks/webhooks.slice';

import { usePrevious } from '@hook/common/use-previous.hook';
import { useStoreDispatch, useStoreSelector } from '@hook/store/store.hooks';
import { isExist, isString } from '@util/data/is-exist';

const RESET_STORES = [
  accountsActions,
  applicationsActions,
  consumersActions,
  credentialsActions,
  integrationsActions,
  logsActions,
  userActions,
  webhooksActions,
];

const RESET_APIS = [accountApi, applicationApi, consumerApi, credentialApi, integrationApi, userApi];

export const useResetStore = () => {
  const dispatch = useStoreDispatch();
  const token = useStoreSelector((state) => state.auth.data.token);
  const prevToken = usePrevious(token);

  useEffect(() => {
    if (isString(prevToken) && !isExist(token)) {
      dispatch(consumersActions.resetAccess());

      RESET_STORES.forEach((store) => dispatch(store.reset()));

      RESET_APIS.forEach((api) => dispatch(api.util?.resetApiState()));
    }
  }, [prevToken, token]);
};
